import { useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Request failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="app-bg min-h-screen flex items-center justify-center px-4">
      <form onSubmit={submit} className="glass glass-cyan rounded-2xl p-7 w-full max-w-md" data-testid="forgot-form">
        <div className="flex items-center gap-2 mb-1"><KeyRound className="w-5 h-5 text-cyan-400" /><h1 className="font-head font-bold text-lg">Reset password</h1></div>
        <p className="text-xs text-muted-foreground mb-5 font-mono">We'll email a reset link if the account exists</p>
        {sent ? (
          <div className="text-sm text-emerald-300 font-mono" data-testid="forgot-sent">If that account exists, a reset link is on its way. Check your inbox.</div>
        ) : (
          <>
            <div className="space-y-1"><Label className="text-xs uppercase tracking-wide text-muted-foreground font-mono">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="bg-slate-900/60 border-white/10" required /></div>
            <Button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full mt-5 bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold">{busy ? "Sending…" : "Send reset link"}</Button>
          </>
        )}
        <p className="text-xs text-muted-foreground mt-4 text-center font-mono"><Link to="/login" className="text-cyan-400 hover:text-cyan-300">Back to sign in</Link></p>
      </form>
    </div>
  );
}
